import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {filter, distinctUntilChanged, publishLast} from 'rxjs/operators';
import {FxDapHttpClient} from '../fx-http-client';

// 作业隐藏字段（黑名单）
class FxFieldBlockItem {
  fieldNo: string;
  fieldName: string;

  constructor(fieldNo: string, fieldName: string) {
    this.fieldNo = fieldNo || '';
    this.fieldName = fieldName || '';
  }
}

// 作业隐藏字段集合（黑名单）
class FxFieldBlackList {
  [id: string]: Array<FxFieldBlockItem>;
}

@Injectable({
  providedIn: 'root'
})
export class FieldAuthorizedService {
  private restriction: string;
  private fieldAuthorizedSubject: BehaviorSubject<string>;
  private fieldPermissionInfo: any;

  constructor(private http: FxDapHttpClient) {
  }

  /**
   * 設定功能權限資料
   *
   * @param dwAuthorizedId 作業權限ID
   * @param dwActionId 功能按鈕ID
   */
  public setActionAuth(dwAuthorizedId: string, dwActionId: string): void {
    this.restriction = null;
    this.fieldAuthorizedSubject = new BehaviorSubject<string>(this.restriction);
    let authorizedList: FxFieldBlackList; // 作業與功能權限
    this.getProgramHideField(dwAuthorizedId).pipe().subscribe(
      response => {
        authorizedList = <FxFieldBlackList>response;
        const authorized: Array<FxFieldBlockItem> = authorizedList[dwAuthorizedId];

        if (authorized && authorized.length > 0 && authorized.find(item => item.fieldNo === dwActionId)) {
          this.restriction = 'hidden';
        }
        this.fieldAuthorizedSubject.next(this.restriction);
      },
      (error: any) => {
        authorizedList = {};
      }
    );
  }

  /**
   * 提供訂閱功能權限資料
   */
  get fieldAuthorizedSubject$(): Observable<string> {
    return this.fieldAuthorizedSubject.asObservable().pipe(
      filter(obsData => obsData !== null), // 不廣播初始值
      distinctUntilChanged() // 有改變時才廣播
    );
  }

  getProgramHideField(programId: string): Observable<any> {
    return Observable.create(observer => {
      this.http.post('A/IACommonService/getProgramHideField', {param: {program_no: programId}}).subscribe(
        response => {
          if (response.success && response.data) {
            observer.next(response.data.map(item => new FxFieldBlockItem(item.field_no, item.field_name)));
          } else {
            observer.error();
          }
          observer.complete();
        }, error => {
          observer.error();
        }
      );
    });
  }
}
